export const APP_SHELLS = Object.freeze({
  MODERN: 'modern',
  LEGACY: 'legacy',
  BARE: 'bare'
});

const VALID_SHELLS = Object.values(APP_SHELLS);

export function resolveAppShell(route = {}) {
  const matched = Array.isArray(route.matched) ? route.matched : [];

  for (let index = matched.length - 1; index >= 0; index -= 1) {
    const shell = matched[index] && matched[index].meta && matched[index].meta.appShell;
    if (VALID_SHELLS.includes(shell)) {
      return shell;
    }
  }

  if (route.meta && VALID_SHELLS.includes(route.meta.appShell)) {
    return route.meta.appShell;
  }

  const hidesLegacyMenu = matched.some(record => record && record.meta && record.meta.hideAppMenu)
    || Boolean(route.meta && route.meta.hideAppMenu);

  return hidesLegacyMenu ? APP_SHELLS.BARE : APP_SHELLS.LEGACY;
}
